import { render } from "./InvoiceManage.vue?vue&type=template&id=38b41176"
import script from "./InvoiceManage.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Billing/InvoiceManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38b41176"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38b41176', __exports__)) {
    api.reload('38b41176', __exports__)
  }
  
  module.hot.accept("./InvoiceManage.vue?vue&type=template&id=38b41176", () => {
    api.rerender('38b41176', render)
  })

}


export default __exports__